import type {
    CognitoAuthorizationProvider,
    CognitoAuthProviderDependencies,
    CognitoAuthProviderOptions,
} from './cognito';
import { createCognitoAuthorizationProvider } from './cognito';

type CreateAuthorizationProviderDependencies = Pick<
    CognitoAuthProviderDependencies,
    'apiBaseUrl' | 'clock' | 'logger' | 'validatingHttpFetcher'
>;

export const createAuthorizationProvider = (
    dependencies: CreateAuthorizationProviderDependencies,
    options: CognitoAuthProviderOptions,
): Promise<CognitoAuthorizationProvider> => {
    return createCognitoAuthorizationProvider(
        {
            apiBaseUrl: dependencies.apiBaseUrl,
            clock: dependencies.clock,
            history: globalThis.history,
            location: globalThis.location,
            locks: globalThis.navigator.locks,
            logger: dependencies.logger,
            storage: globalThis.localStorage,
            validatingHttpFetcher: dependencies.validatingHttpFetcher,
        },
        options,
    );
};
